import { useEffect } from 'react';
import { useDeviceValidator } from './../../services/hooks/DeviceValidator';
import ApiHandler from "./../../services/api/ApiHandler";
import localStorageService from './../../helpers/store/StorageService';
import Routes from './Routes';
import CloudLoader from './../components/loader/Loader_02';
import ContainerComponent from './ContainerComponent';
import apiPayload from './../../services/api/ApiPayload';

export default function ContentLayoutComponent() {
  const { deviceInfo, isValidating } = useDeviceValidator();
  let { data, loading, error, handlePostApi } = ApiHandler();

  useEffect(() => {
    // Prevent repeat calls with a mounted check
    let isDeviceValidated = false;
    let isMounted = true;
    if (isMounted) {
      apiPayload.set('load.pageId', 'Page30001');
      apiPayload.set('load.redirectRoute', '/welcome');
      apiPayload.set('load.data.userId', localStorageService.get('active', -1, 'int'));
      handlePostApi("/v1", apiPayload.fetchPayload());
    }

    if (deviceInfo && !isValidating) {
      isDeviceValidated = true;
      console.log("Validated device configurations : " + isDeviceValidated.toString());

      // TODO : Call api for log and record device info
      // Important : Recheck each api deny from ip cloning, ip spoofing and other vpn activities
    }

    // Cleanup to prevent updates after unmount
    return () => {
      isMounted = false;
    };
    // TODO : Clear the warning
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div className="header">
        {data && <Routes appRoutes={ data.result.api_request_data.nav_links } isAuth={data.result.api_request_data.is_auth} error={ error } loader={ loading }/>}
      </div>
      <main className="main">
        {loading && <CloudLoader />}
        {data && <ContainerComponent navRoutes={ data.result.api_request_data.nav_routes } status={data.code} highlights={data.result.api_request_data.welcome_highlights} contentData={ data.result.api_request_data.api_request_data } error={ error } loader={ loading }/>}
      </main>
    </div>
  );
}
